export const translateErrorMessage = (message: string) => {
  switch (message) {
    case 'Not a valid number.': return 'Vui lòng điền số (không có đơn vị) vào đây.'
    case 'Not a valid date.': return `Vui lòng điền theo format YYYY-MM-DD vào đây.`
  }
  return message
}